export const LessonRiskyProperties = [
  "id",
  "sourceLessonId",
  "sectionId",
  "isThumbnailChanged",
]

export const CourseRiskyProperties = [
  "id",
  "sourceLessonId",
  "sectionId",
  "status",
  "title",
  "url",
  "seqNo",
  "isThumbnailChanged",
  "thumbnail"
]

type Changes = {
  [key: string]: {
    before: any;
    after: any;
  }
}

export default class OCHSimpleChanges {

  private riskyLessonProperties = [
    "id",
    "sourceLessonId",
    "sectionId",
    "status",
    "title",
    "url",
    "seqNo",
    "isThumbnailChanged",
    "thumbnail"
  ]

  static getInstance() {
    return new OCHSimpleChanges();
  }

  setRiskyLessonProperties(newProperties: string[]) {
    this.riskyLessonProperties = newProperties
  }

  public findChanges(beforeData: any, afterData: any): Changes {
    const changes = {};

    // Get all unique keys from both beforeData and afterData
    const allKeys = new Set([...Object.keys(beforeData), ...Object.keys(afterData)]);

    allKeys.forEach(key => {
      if (beforeData[key] !== afterData[key]) {
        changes[key] = {
          before: beforeData[key],
          after: afterData[key]
        };
      }
    });

    return changes;
  }

  public mergeChanges(changes: Changes) {

    const lesson = {}

    Object.entries(changes).forEach((change) => {
      const [property, {after}] = change

      // do not update id on clone lessons
      if (!this.riskyLessonProperties.includes(property)) {

        if(after !== null && after !== undefined) {
          lesson[property] = after
        }

      }

    })

    return lesson

  }


  removeProperties(obj, propsToRemove: string[] = []) {

    const newObj = { ...obj };

    for (const prop of propsToRemove) {
      delete newObj[prop];
    }

    return newObj;

  }

  removeReviewSystemProps(course: any) {

    const reviewSystemProps = ['courseReviewSettings', 'numberPendingReviews', 'latestCourseReviews'];

    return this.removeProperties(course, reviewSystemProps);

  }

}
